<ul class="breadcrumb">
  @for (breadcrumb of breadcrumbsSig(); track $index; let isLast = $last) {
    <li class="breadcrumb__list-item"
      [ngClass]="{ 'breadcrumb__list-item--last': isLast }"
    ><a [routerLink]="breadcrumb.url" >{{ breadcrumb.label }}</a></li>
  }
</ul>
